import { render, staticRenderFns } from "./majorTransfer.vue?vue&type=template&id=61d8cef0&scoped=true&"
import script from "./majorTransfer.vue?vue&type=script&lang=js&"
export * from "./majorTransfer.vue?vue&type=script&lang=js&"
import style0 from "./majorTransfer.vue?vue&type=style&index=0&id=61d8cef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8cef0",
  null
  
)

export default component.exports